import React from "react";
import { Flex, Heading } from "theme-ui";
import { Testimonial } from "../molecules";
import { typography } from "../../styles/theme";

const TestimonialSection = ({
  nodes,
  heading,
  backgroundColor,
  customStyles,
}) => {
  return (
    <Flex
      id="feature-clients"
      sx={{
        ...styles.container,
        ...customStyles,
      }}
    >
      <Heading
        as="h2"
        sx={{
          ...typography.h2,
          textAlign: "center",
        }}
      >
        {heading}
      </Heading>
      <Flex sx={styles.wrapper}>
        {nodes?.map((t, i) => (
          <Testimonial
            key={`testimonial-${i}`}
            variant="main"
            employeeDesignation={t?.employeeDesignation}
            employeeName={t?.employeeName}
            feedback={t?.feedback}
            rating={t?.rating}
            image={t?.testimonialImage?.gatsbyImageData}
            imageAltText={`${t?.employeeName}-${t?.testimonialImage?.alt}`}
            companyName={t?.companyName}
            companyLogo={t?.companyLogo?.gatsbyImageData}
            companyLogoAltText={t?.companyLogoAltText}
            caseSection="Case Study"
            caseSectionColor="secondaryBlue"
            labelOneColor="secondaryGreen"
            labelTwoColor="secondaryBlue"
            customStyles={{ width: "100%" }}
          />
        ))}
      </Flex>
    </Flex>
  );
};

const styles = {
  container: {
    mt: [5, 5, "7rem", "7rem"],
    px: [3, 3, 4, "6.25rem"],
    alignItems: "center",
    flexDirection: "column",
  },
  wrapper: {
    gap: ["2rem", "2rem", "3rem", "3rem"],
    mt: "4rem",
    flexDirection: "row",
    "@media(max-width: 1200px)": {
      flexDirection: "column",
      gap: "2.5rem",
    },
  },
};

export default TestimonialSection;
